export const isDevelopmentTimer =
  String(process.env.REACT_APP_TIMER || "production").trim().toLowerCase() ===
  "development";

export const encodeMaterialDuration = (duration: {
  months: number;
  days: number;
}) =>
  isDevelopmentTimer
    ? duration.months * 60 + duration.days
    : duration.months * 30 + duration.days;

export const splitMaterialDuration = (total: number) => ({
  months: Math.floor(total / (isDevelopmentTimer ? 60 : 30)),
  days: total % (isDevelopmentTimer ? 60 : 30),
});

export const accessUnitLabel = (value: number) =>
  isDevelopmentTimer
    ? Number(value) === 1
      ? "minute"
      : "minutes"
    : Number(value) === 1
      ? "day"
      : "days";
